import { Component, Input, OnInit } from '@angular/core';
import { TableService } from '@app/shared/services/table.service';
import { NbDialogRef, NbToastrService } from '@nebular/theme';

@Component({
  selector: 'ngx-customize-table',
  templateUrl: './customize-table.component.html',
  styleUrls: ['./customize-table.component.scss']
})
export class CustomizeTableComponent implements OnInit {

  constructor(
    protected ref: NbDialogRef<CustomizeTableComponent>,
    private toastrService: NbToastrService,
    private tableService: TableService
  ) { }

  @Input() parentTableHeader = [];
  @Input() tableName = '';
  systemConfigColor;
  @Input() columns = [];
  @Input()  prasentCloum = [];

  Showingonly : number;
  allMenuData : any = []

  ngOnInit(){
    const allMenus = this.columns?.map((res) => {
      const foundInst = this.parentTableHeader?.find((inst: any) => inst?.name === res?.name);
      return {
        name : res.name,
        lable : res?.label,
        visible : !foundInst ? false: true
      }
    })


    const findExsist = allMenus?.filter((res) => res?.visible == true)

    this.Showingonly = findExsist?.length;

    this.allMenuData = allMenus;
    this.tableService.$systemConfig.subscribe((res: any) => {
      if (res) {
        this.systemConfigColor = res.IconColors;
      }
    })
  }

  close() {
    this.ref.close(false);

  }

  save(){
    this.ref.close(this.allMenuData);
  }

  checkExsistData (keys , index) {
    this.allMenuData[index].visible = keys;
    const findExsist =  this.allMenuData?.filter((res) => res?.visible == true)
    this.Showingonly = findExsist?.length;
  }

}
